import { useCallback, useRef } from "react";

interface IUseIntersectionElementProps {
  isLoading: boolean;
  enabled: boolean;
  onIntersectionCallback: () => void;
}

const useIntersectionElement = ({ isLoading, enabled, onIntersectionCallback }: IUseIntersectionElementProps) => {
  const intObserver = useRef<IntersectionObserver | null>(null);
  const intersectingElement = useCallback(
    (observedElement: HTMLDivElement) => {
      if (isLoading) {
        return;
      }

      if (intObserver.current) {
        intObserver.current.disconnect();
      }

      intObserver.current = new IntersectionObserver((elements) => {
        // We are near the last element
        if (elements[0].isIntersecting && enabled) {
          onIntersectionCallback();
        }
      });

      if (observedElement) {
        intObserver.current.observe(observedElement);
      }
    },
    [isLoading, enabled, onIntersectionCallback]
  );
  return intersectingElement;
};

export default useIntersectionElement;
